import { Component, OnInit, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import Color from 'color';
import { BrandThemeSettings, WhitelabellingService } from '@parashift/shared/services';
import { LogoUploadResizeComponent } from '../logo-upload-resize/logo-upload-resize.component';

@Component({
  selector: 'tenant-settings-brand-theme',
  templateUrl: './tenant-settings-brand-theme.component.html',
  imports: [
    ReactiveFormsModule,
    FormsModule,
    LogoUploadResizeComponent
],
})
export class TenantSettingsBrandThemeComponent implements OnInit {
  private whitelabellingService = inject(WhitelabellingService);
  private destroyRef = inject<DestroyRef>(DestroyRef);

  brandThemeSettings: BrandThemeSettings = {
    primaryColor: '',
    secondaryColor: '',
    logoUrl: '',
  };

  ngOnInit() {
    this.whitelabellingService.brandThemeSettings$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(settings => this.brandThemeSettings = settings as BrandThemeSettings);
  }

  setPrimaryColor(primaryColor: string) {
    const color = Color(primaryColor);

    this.whitelabellingService.setBrandThemeColors({
      primaryColor,
      secondaryColor: color.desaturate(0.2).darken(0.3).hex()
    });
  }

  setSecondaryColor(secondaryColor: string) {
    this.whitelabellingService.setBrandThemeColors({
      primaryColor: this.brandThemeSettings.primaryColor,
      secondaryColor
    });
  }

  resetBrandTheme() {
    this.whitelabellingService.resetBrandTheme();
  }
}
